<ng-template #header>
    <shared-vcard-for-wizzard [title]="(singleProduct$ | async)?.PosDisplay"
        [description]="(singleProduct$ | async)?.PosDescription" [stats]="(singleProductStats$ | async)"
        [tagImages]="(singleProductTagImages$ | async)" [collapsed]="false" [loading]="(imageLoading$ | async)"
        [imageSrc]="(singleProductImage$ | async)">
    </shared-vcard-for-wizzard>

    <shared-disclaimer *ngIf="(showContent$ | async) === false && (singleProductStats$ | async)?.cals > 0">
    </shared-disclaimer>

</ng-template>

<ng-template #footer>
    <shared-modal-item-actions [twoColumnsAlign]="twoColumnsAlign" [twoColumnsAdjust]="twoColumnsAdjust"
        [twoColumnsMarginBottom]="twoColumnsMarginBottom" [quantity]="singleProductQuantity$ | async"
        [buttonLabel]="(singleProduct$ | async)?._Id ? 'Edit' : 'Add to bag'"
        [buttonPrice]="singleProductTotalValue$ | async" (onIncrement)="handleSingleProductIncrement($event)"
        (onDecrement)="handleSingleProductDecrement($event)" (onRemove)="handleSingleProductRemove($event)"
        (onClick)="handleSingleProductCtaClick($event)" [minimumHide]="minimumHide" [remove]="remove">
    </shared-modal-item-actions>
</ng-template>

<shared-modal-type-dynamic-height [dimmedBg]="dimmedBg" [header]="header" [footer]="footer"
    [minHeight]="(showContent$ | async) ? minHeight : 0" [shadow]="(showContent$ | async) ? shadow : false"
    [modalData]="modalData" [center]="true" (onCloseClick)="handleCloseClick($event)" [hasSpecialInstructions]="(hasSpecialInstructions$ | async)"
    class="modal-view-for-single-product">

    <shared-wizzards [showDisclaimer]="(singleProductStats$ | async)?.cals > 0" [type]="modalData.type"
                     [menuFlowId]="modalData.menuFlowId" [locationNo]="modalData.locationNo">
    </shared-wizzards>

</shared-modal-type-dynamic-height>
